
import { defineComponent, onMounted, ref, watch } from "vue";
import axios from "@/axios-instance";
import moment from "moment";

export default defineComponent({
  name: "WidgetAssignHistory",
  props: {
    widgetClasses: String,
    idStudent: String,
  },
  setup(props) {
    const histories = ref<any[]>([]);
    const loading = ref(false);

    const fetchHistory = async () => {
      if (!props.idStudent) return;
      loading.value = true;
      try {
        const { data } = await axios.get(`/applicant/assignee-history/${props.idStudent}`);
        histories.value = data;
      } catch (error) {
        console.error("Failed to fetch assign history:", error);
      } finally {
        loading.value = false;
      }
    };

    const formatTime = (date) => moment(date).format("DD/MM HH:mm");
    
    const dotClass = (source) => {
      if (source === 'manual_reassign') return 'text-warning';
      if (source === 'crm_lead_sync') return 'text-primary';
      return 'text-success';
    };

    onMounted(fetchHistory);
    watch(() => props.idStudent, fetchHistory);

    return { histories, loading, formatTime, dotClass };
  },
});
